interface IProps {
  annotationType: number
}

export default function AnnotationTypeIcon({ annotationType }: IProps) {

  return (
    <span>
      {
        annotationType === 10 &&
        <svg fill="none" width="12" height="12">
          <path d="M1 2.5C1 2.03406 1 1.80109 1.07612 1.61732C1.17761 1.37229 1.37229 1.17761 1.61732 1.07612C1.80109 1 2.03406 1 2.5 1H7.5C7.96594 1 8.19891 1 8.38268 1.07612C8.62771 1.17761 8.82239 1.37229 8.92388 1.61732C9 1.80109 9 2.03406 9 2.5M3.5 9H6.5M5 1V9" stroke="#667085" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      }

{
  annotationType === 11 &&
    <svg fill="none" width="12" height="12">
      <path d="M8.00001 4V6.5C8.00001 6.89782 8.15804 7.27936 8.43935 7.56066C8.72065 7.84196 9.10218 8 9.50001 8C9.89783 8 10.2794 7.84196 10.5607 7.56066C10.842 7.27936 11 6.89782 11 6.5V6C10.9999 4.87151 10.6181 3.77624 9.91664 2.89227C9.21516 2.00829 8.23528 1.38761 7.13632 1.13115C6.03737 0.874685 4.88397 0.997521 3.86368 1.47968C2.84339 1.96185 2.0162 2.77498 1.51663 3.78686C1.01706 4.79875 0.874488 5.94987 1.11209 7.05306C1.34969 8.15624 1.95349 9.14662 2.82532 9.86313C3.69715 10.5796 4.78572 10.9802 5.91404 10.9996C7.04236 11.019 8.14406 10.6561 9.04001 9.97M8.00001 6C8.00001 7.10457 7.10458 8 6.00001 8C4.89544 8 4.00001 7.10457 4.00001 6C4.00001 4.89543 4.89544 4 6.00001 4C7.10458 4 8.00001 4.89543 8.00001 6Z" stroke="#667085" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </ svg>
      }

      {
        annotationType === 12 &&
        <span></span>
      }

      {
        annotationType === 40 &&
        <svg fill="none" width="12" height="12">
          <path d="M1 4H9M1 8H9M3 1.5V10.5M7 1.5V10.5" stroke="#667085" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
}

{
  annotationType === 70 &&
    <svg fill="none" width="12" height="12">
      <path d="M10.5 5H1.5M8 1V3M4 1V3M5.25 7L6 6.5V9M5.375 9H6.625M3.9 11H8.1C8.94008 11 9.36012 11 9.68099 10.8365C9.96323 10.6927 10.1927 10.4632 10.3365 10.181C10.5 9.86012 10.5 9.44008 10.5 8.6V4.4C10.5 3.55992 10.5 3.13988 10.3365 2.81901C10.1927 2.53677 9.96323 2.3073 9.68099 2.16349C9.36012 2 8.94008 2 8.1 2H3.9C3.05992 2 2.63988 2 2.31901 2.16349C2.03677 2.3073 1.8073 2.53677 1.66349 2.81901C1.5 3.13988 1.5 3.55992 1.5 4.4V8.6C1.5 9.44008 1.5 9.86012 1.66349 10.181C1.8073 10.4632 2.03677 10.6927 2.31901 10.8365C2.63988 11 3.05992 11 3.9 11Z" stroke="#667085" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </ svg>
      }

      {
        annotationType === 71 &&
        <span></span>
      }

      {
        annotationType === 72 &&
        <span></span>
      }
    </span>
  )
}